import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import React, { ReactNode } from "react";

import "./Dialogs.scss";

export interface ModalMessageDialogProps {
  message: string;
  nonInteractiveMessage?: string;
  title?: string;
  content?: ReactNode;
  onOkClick?: Function;
  okCaption?: string;
  okActionDisabled?: boolean;
  onAbortClick?: Function;
  abortCaption?: string;
}

const ModalMessageDialog: React.FC<ModalMessageDialogProps> = (
  props: ModalMessageDialogProps
) => {
  const singleAction =
    (props.onOkClick && !props.onAbortClick) ||
    (props.onAbortClick && !props.onOkClick);
  const dialogClassName = singleAction
    ? "actionButtonContainer"
    : "actionsButtonContainer";
  return (
    <Dialog open>
      {props.title && (
        <DialogTitle>
          <Typography variant="h2">{props.title}</Typography>
        </DialogTitle>
      )}
      <DialogContent>
        {props.content && <DialogContent> {props.content} </DialogContent>}
        {!props.content && !props.nonInteractiveMessage && (
          <DialogContentText>{props.message}</DialogContentText>
        )}
        {!props.content && props.nonInteractiveMessage && (
          <DialogContent>
            {" "}
            <Stack className="modalMessageDialog__nonInteractiveContainer">
              <CircularProgress />
              <DialogContentText ml={2}>
                {props.nonInteractiveMessage}
              </DialogContentText>
            </Stack>{" "}
          </DialogContent>
        )}
      </DialogContent>
      <DialogActions className={dialogClassName}>
        {props.onOkClick && (
          <Button
            variant="contained"
            disabled={props.okActionDisabled}
            onClick={() => props.onOkClick!()}
          >
            {props.okCaption ?? "OK"}
          </Button>
        )}
        {props.onAbortClick && (
          <Button
            onClick={() => props.onAbortClick!()}
            sx={{ display: "inline" }}
          >
            {props.abortCaption ?? "Abbrechen"}
          </Button>
        )}
      </DialogActions>
      {props.content && props.nonInteractiveMessage && (
        <Box className="modalMessageDialog__nonInteractiveOverlay">
          <Stack className="modalMessageDialog__nonInteractiveContainer">
            <CircularProgress />
            <DialogContentText ml={2}>
              {props.nonInteractiveMessage}
            </DialogContentText>
          </Stack>
        </Box>
      )}
    </Dialog>
  );
};

export default ModalMessageDialog;
